// header-loader.js - Loads shared header HTML into pages

(function() {
  // Determine the correct path to header files based on current page location
  function getHeaderPath(type) {
    const path = window.location.pathname;
    
    // Count directory depth by checking how many levels deep we are
    if (path.includes('/swapper/swap/') || path.includes('/swapper/autoswap/')) {
      // Two levels deep: /swapper/swap/ or /swapper/autoswap/
      return `/header/header-${type}`;
    } else if (path.includes('/swapper/')) {
      // One level deep: /swapper/
      return `/header/header-${type}`;
    }
    
    // Root level
    return `/header/header-${type}`;
  }
  
  // Load header when DOM is ready
  function loadHeader() {
    const headerContainer = document.getElementById('header-container');
    
    if (!headerContainer) {
      console.warn('Header container not found');
      return;
    }
    
    // Show loading skeleton immediately
    const headerType = headerContainer.getAttribute('data-header-type') || 'simple';
    headerContainer.innerHTML = `
      <div class="header-loading-skeleton">
        <div class="header-skeleton-content">
          <div class="header-skeleton-logo"></div>
          <div class="header-skeleton-title"></div>
        </div>
      </div>
    `;
    
    // Determine which header type to load (default: simple)
    const headerPath = getHeaderPath(headerType);
    
    fetch(headerPath)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Failed to load header: ${response.status}`);
        }
        return response.text();
      })
      .then(html => {
        headerContainer.innerHTML = html;
        
        // Initialize header.js functionality for both header types
        const initHeader = () => {
          if (window.AquaVaultsHeader && window.AquaVaultsHeader.init) {
            window.AquaVaultsHeader.init();
            
            // Mount wallet widget only for full header (has av-wallet div)
            if (headerType === 'full' && window.AquaVaultsWalletWidget && window.AquaVaultsWalletWidget.mount) {
              window.AquaVaultsWalletWidget.mount({ el: 'av-wallet', autoConnect: true });
            }
          } else {
            setTimeout(initHeader, 50);
          }
        };
        initHeader();
      })
      .catch(error => {
        console.error('Error loading header:', error);
        // Fallback: insert basic header
        headerContainer.innerHTML = '<header class="app-header"><div class="header-center"><h1 class="header-title">AquaVaults</h1></div></header>';
      });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadHeader);
  } else {
    loadHeader();
  }
})();